import axios from "../axios/axios";
import { apiSetAlert } from "./appApi";
import { errorDispatcher, formatDate, getOptionsQuery, setSelectItemLabels } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { setTransfers } from "../store/actions/transferAction";
import { selectTableItems } from "../store/actions";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { setFormDataTransfer } from "../helpers/FormDataCreator";
import { setEditItem } from "../store/actions/formAction";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetTransfersExcel = (token, transferType, selectedIds) => (dispatch, getState) => {
  let url = "transfers/excel/export";
  if (selectedIds && selectedIds.length > 0) {
    url += `?ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      fileDownload(response.data, `transfers_${now}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetTransfer = (transferId, token, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`transfers/${transferId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      let transfer = response.data.transfer;

      if (callback) {
        callback(transfer);
      } else {
        const transferFrom = setSelectItemLabels(transfer.from, "id", "name");
        const transferTo = setSelectItemLabels(transfer.to, "id", "name");
        const date = formatDate(transfer.date, true, true);
        transfer = {
          ...transfer,
          date,
          from: transferFrom,
          to: transferTo,
        };

        dispatch(setEditItem(transfer));
      }
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetTransfers =
  ({ pagination, token, key, sort, search }) =>
  (dispatch, getState) => {
    let options = getOptionsQuery(pagination, search, sort);

    dispatch(appSetLoading());
    axios
      .post(`/transfers/list`, options, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(setTableData(response.data.transfers, response.data.paginate));
        // dispatch(setTransfers(response.data.transfers));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiDeleteTransfers = (selectedIds, token, tab, callback) => (dispatch, getState) => {
  const transferIds = selectedIds;
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  axios
    .delete(`/transfers/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { transferIds },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSaveTransfer = (form, token, navigate) => (dispatch, getState) => {
  const formData = setFormDataTransfer(form);
  dispatch(appSetSendingRequest(true));
  axios
    .post(`/transfers`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/transfers");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateTransfer = (transferId, form, token, navigate) => (dispatch, getState) => {
  const formData = setFormDataTransfer(form);

  dispatch(appSetSendingRequest(true));
  axios
    .put(`transfers/${transferId}`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/transfers");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
